function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import * as httpProtocol from './httpProtocol';
import { logError } from '@shared/utils/httpClientUtil';
import { getAppConfig } from '@shared/services/init/appConfig';
import { getCustomersFromLeads } from './leadgenRestClient';
const option = {
    requireCorrelationId: true,
    authenticationType: httpProtocol.AuthenticationTypes.Spza,
    retry: 3
};
/**
 * Returns customer object with address and other customer information.
 * If serverBypass feature flag is true, calls the Leads API directly.
 * Otherwise, uses the normal AppSource backend route.
 *
 * @export
 * @param {boolean} serverBypass - Feature flag to bypass server and call Leads API directly
 * @returns {Promise<ICustomer[]>}
 */ export function getCustomers(serverBypass = false) {
    return _async_to_generator(function*() {
        if (serverBypass) {
            return getCustomersFromLeads().catch((error)=>{
                logError('purchaseRestClient.getCustomersLeads', error);
                return Promise.reject(error);
            });
        }
        const endpoint = '/view/customers';
        return httpProtocol.get(endpoint, option).request().catch((error)=>{
            logError('purchaseRestClient.getCustomersMPAPI', error);
            return Promise.reject(error);
        });
    })();
}
/**
 * Creates a new object with the data that's passed in.
 *
 * @export
 * @param {ICustomer} customerRequest
 * @returns
 */ export function createCustomer(customer) {
    const endpoint = '/view/customer';
    const post = httpProtocol.post(endpoint, option);
    return post.setData(customer).request().catch((error)=>{
        logError('purchaseRestClient.createCustomer', error);
        return Promise.reject(error);
    });
}
/**
 * Updates the customer address with the data that's passed in.
 *
 * @export
 * @param {ICustomer} customerRequest
 * @returns
 */ export function updateCustomer(address) {
    const endpoint = '/view/address';
    const post = httpProtocol.post(endpoint, option);
    return post.addQueryEntry('version', getAppConfig('apiVersion')).setData(address).request().catch((error)=>{
        logError('purchaseRestClient.updateCustomer', error);
        return Promise.reject(error);
    });
}
/**
 * Gets publisher offer details for the subscription
 *
 * @export
 * @param {subscriptionId} request
 * @returns
 */ export function getPublisherOfferInfo(subscriptionId) {
    const endpoint = '/view/publisherOfferInfo';
    const post = httpProtocol.post(endpoint, option);
    return post.addQueryEntry('version', getAppConfig('apiVersion')).setData({
        subscriptionId: subscriptionId
    }).request().catch((error)=>{
        logError('purchaseRestClient.publisherOfferInfo', error);
        return Promise.reject(error);
    });
}
